import FullCalendar from "@fullcalendar/react";
import timeGridPlugin  from '@fullcalendar/timegrid';
import resourceTimeGridPlugin           from '@fullcalendar/resource-timegrid';
import resourceDayGridPlugin            from '@fullcalendar/resource-daygrid';
import interactionPlugin                from '@fullcalendar/interaction';
import { useMemo } from "react";

const ReportCalendar = ({clinicians, startDate, finishDate, events}) => {

    const resources    = useMemo(() => clinicians.map(c => ({id: c.ClinicianPartyID, title: c.FirstName + ' ' + c.LastName})),[clinicians] );

    return  <FullCalendar 
            plugins= {[timeGridPlugin, resourceTimeGridPlugin, resourceDayGridPlugin, interactionPlugin]}
            initialView='resourceTimeGridDay'
            locale='en-gb'
            views={{
              resourceTimeGridDay: { type: 'resourceTimeGrid', duration: { days: 5 }, 
              titleFormat: { weekday: 'short', year: 'numeric', month: 'short', day: '2-digit' } }
            }}
            businessHours= {{
                // days of week. an array of zero-based day of week integers (0=Sunday)
                daysOfWeek: [ 1, 2, 3, 4, 5, 6 ], // Monday - Saturday

                startTime: '00:00', // a start time (10am in this example)
                endTime: '20:00', // an end time (6pm in this example)
          }} 
          slotDuration='00:30:00'
          slotMinTime='00:00:00'
          slotMaxTime='24:00:00'
          scrollTime='13:00:00'
          height= {'auto'}
          contentHeight={'auto'}
          events={events}
          resources={resources}
          headerToolbar={{
              left: 'prev,next',
              center: 'title',
              right: ''
          }}
          defaultDate={startDate}
          validRange= {{
            start: startDate,
            end: finishDate
          }}
          filterResourcesWithEvents={true}
          schedulerLicenseKey={schedulerLicenseKey}
        />
};

/* This is the license key which allows use of paid for views of the calendar.
 * See env.local and .env files. */
const schedulerLicenseKey =  process.env.REACT_APP_SCHEDULER_LICENSE_KEY;

export default ReportCalendar;